import React from 'react';
import { Icon } from './Icon';
import { Icons } from '@/assets';

export const PaginationV2 = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems = 0,
  itemsPerPage = 10,
  className = '',
}) => {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <button
        key="prev"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={` text-inactive-text gap-1 text-xs border-none shadow-none bg-transparent flex items-center justify-center ${
          currentPage === 1
            ? 'opacity-40 cursor-not-allowed'
            : ' cursor-pointer'
        }`}>
        <Icon
          src={Icons.arrowBack}
          width="14px"
          height="14px"
          color="#717784"
        />
        Previous
      </button>
    );

    // Page numbers wrapper
    const pageNumbers = [];

    if (totalPages <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`w-6 h-6 cursor-pointer flex items-center justify-center text-xs  rounded-full border-none shadow-none ${
              currentPage === i
                ? 'bg-light-bg text-primary-text'
                : 'bg-transparent text-border-secondary hover:bg-gray-50'
            }`}>
            {i}
          </button>
        );
      }
    } else {
      // Show first 3 pages
      for (let i = 1; i <= 3; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`w-6 h-6 cursor-pointer flex items-center justify-center text-xs  rounded-full border-none shadow-none ${
              currentPage === i
                ? 'bg-light-bg text-primary-text'
                : 'bg-transparent text-border-secondary hover:bg-gray-50'
            }`}>
            {i}
          </button>
        );
      }

      // Add ellipsis
      pageNumbers.push(
        <span key="ellipsis" className="px-2 py-1 text-sm text-inactive-text">
          ...
        </span>
      );

      // Show last 3 pages
      for (let i = totalPages - 2; i <= totalPages; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`w-6 h-6 cursor-pointer flex items-center justify-center text-xs  rounded-full border-none shadow-none ${
              currentPage === i
                ? 'bg-light-bg text-primary-text'
                : 'bg-transparent text-border-secondary hover:bg-gray-50'
            }`}>
            {i}
          </button>
        );
      }
    }

    // Add page numbers wrapper to buttons
    buttons.push(
      <div key="page-numbers" className="flex items-center gap-1">
        {pageNumbers}
      </div>
    );

    // Next button
    buttons.push(
      <button
        key="next"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={` text-inactive-text text-xs gap-1 border-none shadow-none bg-transparent flex items-center justify-center ${
          currentPage === totalPages
            ? 'opacity-40 cursor-not-allowed'
            : 'cursor-pointer '
        }`}>
        Next
        <Icon
          src={Icons.arrowBack}
          width="14px"
          height="14px"
          color="#717784"
          style={{
            transform: 'rotate(180deg)',
          }}
        />
      </button>
    );

    return buttons;
  };

  if (totalPages <= 1) return null;

  return (
    <div className={`w-full ${className} `}>
      <div className="flex justify-between items-center gap-2 px-6">
        {renderPaginationButtons()}
      </div>
    </div>
  );
};
